import { useEffect, useRef } from "react";
import { Box, Button } from "@mui/material";
import { Item } from "../models/Items/Item";
import QuoteList from "../pages/Products/Quotes/QuoteList";
import { Add, Refresh } from "@mui/icons-material";

type ProductCommentsProps = {
  productId: number;
  selectedQuote: string;
  setSelectedVendorForQuote: (value: number) => void;
  isRefreshCalled: boolean;
  setIsRefreshCalled: (newValue: boolean) => void;
  setQuotesForEditProductPage: (value: any) => void;
  quotesForEditProductPage: any[];
  handleQuoteSelection: (event: any, id: string) => Promise<void>;
  editItem: Item;
};

const AcceptedQuote = (props: ProductCommentsProps) => {

  const {
    productId,
    selectedQuote,
    setSelectedVendorForQuote,
    isRefreshCalled,
    setIsRefreshCalled,
    setQuotesForEditProductPage,
    quotesForEditProductPage,
    handleQuoteSelection,
    editItem
  } = props;

  const hasQuoteDefaultSelected = useRef(false);
  

  useEffect(() => {
    if (quotesForEditProductPage?.length > 0 && selectedQuote && !hasQuoteDefaultSelected.current) {
      hasQuoteDefaultSelected.current = true;

      const selectedVendorId = quotesForEditProductPage.find(q => +q.id == +selectedQuote)?.vendor || null;
      setSelectedVendorForQuote(selectedVendorId);
    }
  }, [quotesForEditProductPage, selectedQuote]);

  return (
    <Box className="accepted-quotes-grid-box">
      <Box className="flex manage-quotes-actions">
        <Box className="action-buttons">
          <Button onClick={() => setIsRefreshCalled(true)} variant="contained">
            <Refresh />
            Refresh
          </Button>
          <Button variant="contained" component="a" target="_blank" 
          onClick={() => {
            window.open(`/create-quote?productId=${editItem?.id}`, "_blank", "noopener,noreferrer");
          }}
          >
            <Add />
            Create New Quote
          </Button>
        </Box>
      </Box>
      <QuoteList 
        handleQuoteSelection={handleQuoteSelection} 
        isEditProductPage 
        isRefreshCalled={isRefreshCalled} 
        setIsRefreshCalled={setIsRefreshCalled} 
        productId={productId}
        setQuotesForEditProductPage={setQuotesForEditProductPage}
      />
    </Box>
  )
}

export default AcceptedQuote;